// extracted by mini-css-extract-plugin
module.exports = {"container":"NoCollectionTours_container__1pWzq"};